import type { JDSAvatarV2NotificationProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSAvatarV2NotificationProps>
  ): React.FC<JDSAvatarV2NotificationProps> =>
  (props: JDSAvatarV2NotificationProps) => {
    return <Component {...props} />;
  };
export { JDSAvatarV2NotificationProps };
